Ext.define('SA.model.BetweenCondition', {
    constructor({attributeId, gteOperand, lteOperand}) {
        this.attributeId = attributeId;
        this.gteOperand = gteOperand;
        this.lteOperand = lteOperand;
    },

    getAttributeId() {
        return this.attributeId;
    },

    getGteOperand() {
        return this.gteOperand;
    },

    getLteOperand() {
        return this.lteOperand;
    },

    isBetweenCondition() {
        return true;
    },

    toPredicate() {
        var gte = SA.Predicate.gte(this.getAttributeId(), this.getGteOperand()),
            lte = SA.Predicate.lte(this.getAttributeId(), this.getLteOperand());

        return SA.Predicate.and([gte, lte]);
    }
});